import LayoutLanding from "./LayoutLanding.vue";
import SearchResultsHeader from "@/components/SearchResultsHeader/SearchResultsHeader.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import RelatedArticles from "@/components/RelatedArticles/RelatedArticles.vue";
import MentionedIn from "@/components/MentionedIn/MentionedIn.vue";
import MobileNav from "@/components/MobileNav/MobileNav.vue";
import { mapGetters } from "vuex";
import { adSubdomain } from "@/common/functions";
import { isSmallDevice } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    name: "LayoutLanding",
    components: {
        Advertising,
        SearchResultsHeader,
        Sidebar,
        RelatedArticles,
        MentionedIn,
        MobileNav
    },
    data() {
        return {
            mobileNavIsOpen: false,
            layout: "LayoutLanding",
            subdomain: adSubdomain(this.$route.meta.subdomain),
            noresults: false
        };
    },
    methods: {
        mobileMenuToggle(value) {
            this.mobileNavIsOpen = value;
        },
        isSmallDevice,
        isNoResultsPage() {
            const loc = window.location;
            if (loc.pathname === "/404/no-results") {
                this.noresults = true;
            }
        }
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    created() {
        this.$parent.$emit("upadate:layout", LayoutLanding);
        this.$parent.$emit("upadate:noresults");
        this.isNoResultsPage();
    }
};



// WEBPACK FOOTER //
// ./src/layouts/LayoutLanding/LayoutLanding.js